module.exports = __webpack_public_path__ + "static/img/experiencia.6fed8b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experiencia.jpg
// module id = uRG2
// module chunks = 47